import User from './containers/UserContainer';

export default User;
